function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagBH(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURdEYLtodNOMhOfz8/PT09O6vtt4wReRmdfTl5rp8RYgAAAGBSURBVDjLzZBBbsMgEEXHNwCfIOQKdqTsIRLbbryue4K6Z6BSj93/Z3DiKLip1E0ngAn/8efbMqw1HVt1kCswfjwBhtPbH4GnLZ6G/A9vcW616O9C9o8VtkAgEUI48tfXxW1bhNAbErjazsk4DhED8zQHE1m+7uhAfcA8zTin4oPpHjs4kKDNeaGEY17vPVHsDhIp4jsOk/e4QoGPXhHvNUMaU4px4jmclQgm9wAYb6RDXvx9MZA6xIQZ03CZ+5sa6tNJiokNsF5m/1hokRCBNufFNwG48/44Tr4NUEwwSASc950JHTcYItoBRMyLM71jYd8B6tYM/BQISUEpRzf+pL4FqctcL4qZmJGYjJEXvd+pM3dOCQJWk4irlyBKhSykAXqg92R1ELdxyO/4L5h6bE8gNyBdXnlQCSyi8w7AAcZa6G8Zri1M1hDO2rG2b9Gs3wBZO7BFEygkioZsAqUaAHA7LUrm+LGF1stuSBrkvAtkRoBL+dprkUopmCl9NkN+AwaSurNbEq0yAAAAAElFTkSuQmCC",
    alt: "BH"
  }, props));
}